// extracted by mini-css-extract-plugin
module.exports = {"section":"RegisterSuccessPage_section__31Khq","box":"RegisterSuccessPage_box__1LkQQ","eyebrow":"RegisterSuccessPage_eyebrow__ofz-C","button":"RegisterSuccessPage_button__2mfTN"};